import { first, mergeMap, tap, finalize, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TapeChartWikiComponent } from '../tape-chart-wiki/tape-chart-wiki.component';
import {Component, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild} from '@angular/core';
import { SearchTemplateComponent } from '@app/_components/report/search-template/search-template.component';
import { AlertService } from '@app/_services';
import { DatePipe } from '@angular/common';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { TapeChartWikiService } from '../tape-chart-wiki.service';
import { TapeChart } from '../tape-chart-wiki';
import {Location} from '@angular/common';
import { ReservationContainerComponent } from '@app/_components/reservation/components/reservation/reservation-container/reservation-container.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ReservationService } from '@app/_components/reservation/reservation.service';
import { OrderComponent } from '@app/_components/order/order/order.component';
import * as moment from 'moment';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators, ValidationErrors } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ReservationCreateComponent } from '@app/_components/reservation/components/reservation-create/reservation-create.component';
import { OrderDetailService } from '@app/_components/reservation/components/reservation/order-detail/order-detail.service';
import { ReservationsService } from '@app/_components/yield-max/reservation';
import { QuoteComponent } from '@app/_components/quote/quote/quote.component';
import { QuoteSource } from '@app/_components/quote/quote-source.enum';
import { MaintenanceEventComponent } from '@app/_components/maintenance-event/maintenance-event/maintenance-event.component';
import { MaintenanceEvent } from '@app/_components/maintenance-event/maintenance-event';
import { AvailableWindow, QuoteContext, QuoteContextService } from '@app/_components/quote/quote-context.service';
import { QuoteService } from '@app/_components/quote/quote.service';

@Component({
    selector: 'app-tape-chart-wiki-list',
    templateUrl: './tape-chart-wiki-list.component.html',
    styleUrls: ['./tape-chart-wiki-list.component.css'],
    providers: [MessageService, ConfirmationService],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class TapeChartWikiListComponent implements OnInit {
	constructor(
		private tapeChartWikiService: TapeChartWikiService,
		private orderDetailService: OrderDetailService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private reservationService: ReservationService,
		private ymReservationService: ReservationsService,
		private activatedRoute: ActivatedRoute,
		private location1: Location,
		public dynamicDialogRef: DynamicDialogRef,
		public formBuilder: UntypedFormBuilder,
		private router: Router,
		private dialog: MatDialog,
		private datePipe: DatePipe,
		private quoteContextService: QuoteContextService,
		private quoteService: QuoteService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    // Optional because this component is also reachable via router
    // (not just MatDialog.open). Null when used as a route.
    @Optional() public matDialogRef: MatDialogRef<TapeChartWikiListComponent> | null
  ) {
    // this.msgOrigin = 1;
		this.statuses = tapeChartWikiService.statuses;
		if (this.activatedRoute.snapshot.paramMap.get('shortTermRentalId'))
		{
			this.searchedShortTermRentalId = this.activatedRoute.snapshot.paramMap.get('shortTermRentalId');
		}
		if (this.activatedRoute.snapshot.paramMap.get('startDate'))
		{
			this.searchedStartDate = this.activatedRoute.snapshot.paramMap.get('startDate');
		}
		if (this.activatedRoute.snapshot.paramMap.get('endDate'))
		{
			this.searchedEndDate = this.activatedRoute.snapshot.paramMap.get('endDate');
		}
    if (data){
      this.dialogData = data;
      this.msgOrigin = data?.msgOrigin;
	  this.msgRequest = data?.msgRequest;
      // Smart-parsed quote context passed from the inbox (comm-tool flow)
      this.quoteContext = data?.quoteContext ?? null;
      // Seed the LOS multiselect with the parsed night count so it shows pre-selected on open
      if (this.quoteContext?.flexNumNights) {
        this.flexSelectedNights = [this.quoteContext.flexNumNights];
      }
      this.recomputeFlexPreSetNights();
    }
	}

	get Statuses() {
		return this.statuses;
	}

get f() { return this.form1.controls; }
	reservation: any;



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	@Input() showSearchUI = true;
	@Input() titleFontSize = false;
	@Input() propertyId: any;
	@Output() doRedirectBulkUpdateCB = new EventEmitter<any>();
  @Output() doEmailEvent = new EventEmitter<any>();
  tripPlannerVisible = false;
  msgOrigin: any;
  msgRequest: any;
  dialogData: any;

  /**
   * Quote context injected from the inbox (Smart Parse). When present we:
   *   - auto-fill the search form with parsed dates / resort / party
   *   - auto-switch to Dates mode (so str_rate_detail_los joins & quote is allowed)
   *   - auto-kick off a search on open
   *   - surface a Flexible Date banner when the guest asked for "any N nights"
   * When absent, tape chart behaves exactly as before.
   */
  quoteContext: QuoteContext | null = null;

  flexSearching = false;

  /**
   * Night counts to search for in the flex finder. Initialised from quoteContext.flexNumNights
   * and updated when the reservationist changes the "LOS" multiselect in the search bar.
   * Supports multiple values (e.g. [4, 5]) — runFlexFinder() loops over each and combines results.
   */
  flexSelectedNights: number[] = [];

  /**
   * Feed the pre-set value into the search-template LOS multiselect on first render.
   * Cached as a field (not a getter) so the @Input reference is stable across change-detection
   * cycles — otherwise ngOnChanges fires on every tick and wipes the user's date selection.
   */
  flexPreSetNights: number[] = [];

  private recomputeFlexPreSetNights(): void {
    this.flexPreSetNights = this.flexSelectedNights.length ? this.flexSelectedNights
      : (this.quoteContext?.flexNumNights ? [this.quoteContext.flexNumNights] : []);
  }

  /** Unfiltered rows from the latest search — retained so we can toggle the filter on/off. */
  private allTapeChartsByProperty: any[] = [];
  /** Free-text property-code filter (partial match, case-insensitive). */
  propertyCodeFilter: string = '';
  /** Click-to-pick state: first click on an available cell stashes the property + date; the
   *  next click on another available cell in the same property opens Create Reservation. */
  private pickedStartCell: { rowData: any; rate: any; date: any } | null = null;
  /** True when the context-driven filter is actively hiding rows. */
  contextFilterActive = false;
  /** Counts for the header chip: "3 of 27 properties match". */
  contextMatchedCount = 0;
  contextTotalCount = 0;

  /** Handle to the embedded search template so we can pre-select its multiselects. */
  @ViewChild(SearchTemplateComponent) searchTemplateRef: SearchTemplateComponent;
	tapeCharts: any[] = [];
	tapeChart: TapeChart;
	calculatedYieldPrice: any;

	tapeChartsByProperty: any[] = [];

	scrollingColumns: any[] = [];
	monthNameColumns: any[] = [];
  	frozenColumns: any[] = [];

	// to hold the current search
	currentSearchForm: any = {};

	 // window
	 innerWidth;
	 innerHeight;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = false;
	multiSortMeta = [];

	statuses: any;

	// Show warning message when dates not available for searched range for reservation
	showReservationWarning = false;
	position = 'Top';
	warningMessage = '';
	shortTermRentalBeforeWarning: any;
	checkInBeforeWarning: any;
	checkOutBeforeWarning: any;

	showQuoteWindow = false;
	quoteCheckInDate: any;
	quoteShortTermRentalId: any;
	quotePropertyCode: any;
	quoteMinCheckOutDate: any;
	quoteNumNights: any;
	// For select all option
	selectAllProperties = false;
	showPropertyQuoteBtn = false;
	selectedProperties: any = [];
	rateOptions: any[] = [{ label: 'LOS', value: 'los' }, { label: 'Dates', value: 'dates' }];
	selectedRateOption = 'los';
	showAvailableOnly = false;
	searchWithLosNights: any;
	searchedShortTermRentalId: any;
	searchedStartDate: any;
	searchedEndDate: any;
	searchedMinStayExpected: any;
	selectedRateForOpsNotes: any;
	checkInOutClickCount = 0;

	startDateFound = false; // Flag for searched start date

	columns: any[] = [
		{ field: 'propertyCode', header: 'Property', width: 'auto' },
		// { field: 'analyzedDate', header: 'Date', width: 'auto' },
		// { field: 'listPriceAMT', header: 'List Price', width: 'auto' },
		{ field: 'addressDevelopmentName', header: 'Development', width: 'auto' },
		{ field: 'bedrooms', header: 'Bedrooms', width: 'auto' },
	];

	nightList = [
		{ value: 0, name: 'Rate' },
		{ value: 1, name: '1' },
		{ value: 2, name: '2' },
		{ value: 3, name: '3' },
		{ value: 4, name: '4' },
		{ value: 5, name: '5' },
		{ value: 6, name: '6' },
		{ value: 7, name: '7' },
		{ value: 8, name: '8' },
		{ value: 9, name: '9' },
		{ value: 10, name: '10' },
		{ value: 11, name: '11' },
		{ value: 12, name: '12' },
		{ value: 13, name: '13' },
		{ value: 14, name: '14' },
		{ value: 15, name: '15' },
		{ value: 16, name: '16' },
		{ value: 17, name: '17' },
		{ value: 18, name: '18' },
		{ value: 19, name: '19' },
		{ value: 20, name: '20' },
		{ value: 21, name: '21' },
		{ value: 22, name: '22' },
		{ value: 23, name: '23' },
		{ value: 24, name: '24' },
		{ value: 25, name: '25' },
		{ value: 26, name: '26' },
		{ value: 27, name: '27' },
		{ value: 28, name: '28' },
		{ value: 29, name: '29' },
		{ value: 30, name: '30' },
	];

	opsNoteDetails = [];
	rateFeesDetails = [];
	//Show dialog for OpsNotes with Rate Details calculations
	showOpsNoteDialog: boolean = false;

	// Promotion log dialog
	showPromoLogDialog: boolean = false;
	promoLogAlerts: any[] = [];
	promoLogLoading: boolean = false;
	promoLogReservationId: any = null;
	// Dates captured in local timezone for dry-run (not UTC-shifted like startDateStr/endDateStr)
	promoLogCheckInDate: string = null;
	promoLogCheckOutDate: string = null;

	//Form
	form1: UntypedFormGroup;
	errorList: any = [];
	errorMessages: string;
	formError: any;
	quote: any;
	submitted = false;
	isDateLessThanCheckinDate = false;
	showShortInvoiceDetail = true;
	searchButtonLabel = false;
	couponCode: any;
	isSearching = false;
	checkCouponValidOrNot = false;
	invalidCouponCode: boolean;
	couponCodeSuccessMsg: boolean;
	isCouponCodeIsApply: boolean;
	showCoupon: boolean;
	adults = [
		// { name: 'Adults', value: "" },
		{ name: '1', value: 1 },
		{ name: '2', value: 2 },
		{ name: '3', value: 3 },
		{ name: '4', value: 4 },
		{ name: '5', value: 5 },
		{ name: '6', value: 6 },
		{ name: '7', value: 7 },
		{ name: '8', value: 8 },
		{ name: '9', value: 9 },
		{ name: '10', value: 10 },
		{ name: '11', value: 11 },
		{ name: '12', value: 12 },
		{ name: '13', value: 13 },
		{ name: '14', value: 14 },
		{ name: '15', value: 15 },
		{ name: '16', value: 16 },
		{ name: '17', value: 17 },
		{ name: '18', value: 18 },
		{ name: '19', value: 19 },
		{ name: '20', value: 20 },
	];
	children = [
		// { name: 'Children', value: "" },
		{ name: '0', value: 0 },
		{ name: '1', value: 1 },
		{ name: '2', value: 2 },
		{ name: '3', value: 3 },
		{ name: '4', value: 4 },
		{ name: '5', value: 5 },
		{ name: '6', value: 6 },
		{ name: '7', value: 7 },
		{ name: '8', value: 8 },
		{ name: '9', value: 9 },
		{ name: '10', value: 10 },
		{ name: '11', value: 11 },
		{ name: '12', value: 12 },
		{ name: '13', value: 13 },
		{ name: '14', value: 14 },
		{ name: '15', value: 15 },
		{ name: '16', value: 16 },
		{ name: '17', value: 17 },
		{ name: '18', value: 18 },
		{ name: '19', value: 19 },
		{ name: '20', value: 20 },
	];

	ngOnInit(): void {
		try {
			this.formBuild();
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'analyzedDate', order: 0 });
			this.setInnerWidthHeightParameters();

			if(this.activatedRoute.snapshot.paramMap.get('minStayExpected'))
			{
				const minStayExpected = this.activatedRoute.snapshot.paramMap.get('minStayExpected');
				const minStayExpectedValue = parseInt(minStayExpected, 10); // Ensure it's a number
				// this.searchWithLosNights = this.nightList.find(item => item.value === minStayExpectedValue);
				this.searchWithLosNights = minStayExpectedValue;
				console.log(this.searchWithLosNights)
			}

			// Smart Parse auto-fill — runs when opened from the inbox
			this.applyQuoteContextOnOpen();
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/**
	 * If the inbox supplied a QuoteContext, apply it:
	 *   1. Switch to Dates mode (required by onOpenPropertiesQuote).
	 *   2. Populate search form with check-in / check-out (or flex range).
	 *   3. Trigger search — for flex mode we search the whole range so the
	 *      window finder has enough data to scan.
	 *   4. When results arrive and flexMode is on, runFlexFinder() renders
	 *      quick-pick windows.
	 */
	private applyQuoteContextOnOpen(): void {
		const ctx = this.quoteContext;
		if (!ctx) return;

		// Always prefer Dates mode so the LOS join runs & quote is allowed.
		this.selectedRateOption = 'dates';

		// Pick start/end based on flex vs explicit
		let start = ctx.flexMode ? ctx.flexRangeStart : ctx.checkInDate;
		let end   = ctx.flexMode ? ctx.flexRangeEnd   : ctx.checkOutDate;

		// Fallback: no dates at all → default to "next 60 days" so the
		// reservationist has something to look at instead of an empty chart.
		// The context filter will still narrow to the right resort.
		if (!start || !end) {
			const today = new Date();
			start = start || today;
			end   = end   || new Date(today.getFullYear(), today.getMonth(), today.getDate() + 60);
		}

		this.searchedStartDate = start;
		this.searchedEndDate   = end;

		// Schedule after the search-template has had a chance to bind its
		// @Input() startDate / endDate and render so @ViewChild resolves.
		// applySearchFormFilters() polls until the developments dropdown is
		// ready, patches resort + bedroom filters, then fires a SINGLE
		// tpl.searchClick() — one API call instead of two.
		this.flexSearching = !!ctx.flexMode;
		setTimeout(() => this.applySearchFormFilters(), 400);
	}



	/**
	 * Runs after a tape-chart search completes. Stashes the full list, then
	 * applies the resort + bedroom filter from the quote context so the user
	 * sees only relevant properties — without losing the full set (so they
	 * can click "Show all" to widen).
	 */
	applyContextFilter(): void {
		const ctx = this.quoteContext;
		// stash the full set (first time only, or after every fresh search)
		this.allTapeChartsByProperty = [...this.tapeChartsByProperty];
		this.contextTotalCount = this.allTapeChartsByProperty.length;

		if (!ctx || (!ctx.resortCode && (!ctx.resortKeywords || !ctx.resortKeywords.length) && ctx.bedrooms == null)) {
			this.contextFilterActive = false;
			this.contextMatchedCount = this.contextTotalCount;
			return;
		}

		const filtered = this.quoteContextService.filterPropertiesByContext(this.allTapeChartsByProperty, ctx);
		this.contextMatchedCount = filtered.length;
		if (filtered.length > 0 && filtered.length < this.contextTotalCount) {
			this.tapeChartsByProperty = filtered;
			this.contextFilterActive = true;
		} else {
			this.contextFilterActive = false;
		}
	}

	/** Toggle called by the "Show all N properties" / "Re-apply filter" chips. */
	toggleContextFilter(): void {
		if (this.contextFilterActive) {
			this.tapeChartsByProperty = [...this.allTapeChartsByProperty];
			this.contextFilterActive = false;
		} else {
			this.applyContextFilter();
		}
	}

	/**
	 * Filters the visible rows by a partial/full propertyCode match (case-insensitive).
	 * Triggered by the "Go" button or Enter key in the top-left search box.
	 * An empty filter restores the full result set from the last search.
	 */
	applyPropertyCodeFilter(): void {
		const source = this.allTapeChartsByProperty.length
			? this.allTapeChartsByProperty
			: this.tapeChartsByProperty;
		const q = (this.propertyCodeFilter || '').trim().toLowerCase();
		if (!q) {
			this.tapeChartsByProperty = [...source];
			this.contextFilterActive = false;
			return;
		}
		this.tapeChartsByProperty = source.filter(p =>
			(p.propertyCode || '').toLowerCase().includes(q)
		);
	}

	clearPropertyCodeFilter(): void {
		this.propertyCodeFilter = '';
		this.applyPropertyCodeFilter();
	}

	/**
	 * Called when BestFitListComponent emits (windowPicked).
	 * Highlights the matching property row on the tape chart grid so the
	 * reservationist can see which property was selected.
	 */
	onFlexWindowPicked(win: AvailableWindow): void {
		const target = this.tapeChartsByProperty.find(p => p.propertyCode === win.propertyCode);
		if (target) {
			this.tapeChartsByProperty.forEach(p => p.isSelected = false);
			target.isSelected = true;
			this.selectedProperties = [target];
			this.showPropertyQuoteBtn = true;
		}
	}

	/**
	 * Pre-selects the resort (development) and bedroom values inside the
	 * embedded <app-search-template> so the reservationist can SEE what
	 * filter was applied from the email, and can widen / swap it like a
	 * normal search. Retries until the template has loaded its
	 * `developments` array (async HTTP fetch on its ngOnInit).
	 *
	 * Without this, the filter was "invisible" — only the client-side row
	 * hide was acting, so changing the dropdown cleared the filter silently.
	 */
	private applySearchFormFilters(attempt: number = 0): void {
		const ctx = this.quoteContext;
		if (!ctx) return;
		const tpl = this.searchTemplateRef;
		// Wait up to ~4s for the developments list + form to finish bootstrapping.
		if (!tpl || !tpl.form1) {
			if (attempt < 20) setTimeout(() => this.applySearchFormFilters(attempt + 1), 200);
			return;
		}
		const devsLoaded = !!(tpl['developments'] && tpl['developments'].length);
		if ((ctx.resortCode || (ctx.resortKeywords && ctx.resortKeywords.length)) && !devsLoaded) {
			if (attempt < 20) setTimeout(() => this.applySearchFormFilters(attempt + 1), 200);
			return;
		}

		const patch: any = {};

		// Resort → formDevelopmentIds (the multiselect's optionValue is developmentId)
		if (ctx.resortCode || (ctx.resortKeywords && ctx.resortKeywords.length)) {
			const devs: any[] = tpl['developments'] || [];
			const wantedKeywords = (ctx.resortKeywords || []).map(k => k.toLowerCase());
			const wantedCode = (ctx.resortCode || '').toUpperCase();
			const matches = devs.filter(d => {
				const name = (d.addressDevelopmentName || '').toLowerCase();
				const code = (d.addressDevelopmentCode || '').toUpperCase();
				if (wantedCode && (code === wantedCode || code.startsWith(wantedCode))) return true;
				return wantedKeywords.some(k => k && name.includes(k));
			});
			if (matches.length) {
				patch.formDevelopmentIds = matches.map(d => d.developmentId);
			}
		}

		// Bedrooms → formBedrooms (stores raw numbers)
		if (ctx.bedrooms != null) {
			patch.formBedrooms = [ctx.bedrooms];
		}

		// Apply whatever filters we resolved (may be empty if no context)
		if (Object.keys(patch).length) {
			tpl.form1.patchValue(patch);
		}

		// Fire the single search. [startDate]/[endDate] @Input() bindings have
		// already been pushed into tpl.form1 by Angular change-detection, so
		// the form has correct dates, resort, and bedroom filters all at once.
		this.showAvailableOnly = false;
		tpl.searchClick();
	}

	/**
	 * Closes whichever dialog ref this component was opened through.
	 * Handles both the new MatDialog path (inbox → tape-chart) and the
	 * legacy primeng DynamicDialog path. No-op when accessed as a route
	 * (neither ref is populated). Wired to the close button at the top
	 * right of the template and still called by older code paths that
	 * expected the primeng-based implementation.
	 */
	closeDialog(): void {
		if (this.matDialogRef) { this.matDialogRef.close(); return; }
		if (this.dynamicDialogRef) { this.dynamicDialogRef.close(); }
	}

	sortResult(sortField)
	{
		let searchForm = {};
		Object.assign(searchForm, this.currentSearchForm);
		this.getTapeChartDetails(searchForm, sortField);
	}
	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	onPropertySelection(property)
	{
		let isAllPropertySelected = true;
		this.showPropertyQuoteBtn = false;
		if (property.isSelected)
		{
			this.selectedProperties.push(property);
			this.showPropertyQuoteBtn = true;
		}
		else
		{
			this.selectedProperties = this.selectedProperties.filter(item => item.propertyCode !== property.propertyCode);
		}
		this.tapeChartsByProperty.forEach(property => {
			if (!property.isSelected)
			{
				isAllPropertySelected = false;
				if (this.showPropertyQuoteBtn)
				{
					return;
				}
			}
			else if (!this.showPropertyQuoteBtn)
			{
				this.showPropertyQuoteBtn = true;
			}
		});

		if (isAllPropertySelected)
		{
			this.selectAllProperties = true;
		}
		else
		{
			this.selectAllProperties = false;
		}
	}

	onPropertySelectionAll()
	{
		this.selectedProperties = [];
		if (this.selectAllProperties)
		{
			this.showPropertyQuoteBtn = true;
			this.tapeChartsByProperty.forEach(property => {
				this.selectedProperties.push(property);
				property.isSelected = true;
			});
		}
		else
		{
			this.showPropertyQuoteBtn = false;
			this.tapeChartsByProperty.forEach(property => {
				property.isSelected = false;
			});
		}
	}

	onOpenPropertiesQuote(): MatDialogRef<QuoteComponent> | null
	{
		if (this.selectedRateOption == null || this.selectedRateOption != 'dates')
		{
			this.messageService.add({ severity: 'warn', summary: 'Quote Warning', detail: 'Please select \'Dates\' option beside LOS option for Quote.', life: 3000 });
			return null;
		}
		let searchedStartDate = new Date(this.currentSearchForm.startDate);
		let searchedEndDate = new Date(this.currentSearchForm.endDate);

		// Pull party/guest from smart-parse context when available
		const ctx = this.quoteContext;
		const numAdults   = ctx?.numAdults   != null ? ctx.numAdults   : 2;
		const numChildren = ctx?.numChildren != null ? ctx.numChildren : 0;
		const guestInfo = ctx ? {
			guestName:  ctx.guestName,
			guestEmail: ctx.guestEmail,
			guestPhone: ctx.guestPhone
		} : null;

		const dialogConfig = new MatDialogConfig();
		const data = {
			checkInDate: searchedStartDate,
			checkOutDate: searchedEndDate,
			selectedProperties: this.selectedProperties,
			numAdults:   numAdults,
			numChildren: numChildren,
			guestInfo:   guestInfo,
      		msgOrigin: this.msgOrigin,
			msgRequest: this.msgRequest
		};
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '120vw';
		dialogConfig.width = '75vw';
		dialogConfig.data = {
			title : 'Quote',
			showCloseButton: true,
			quote: data,
      		msgOrigin : this.msgOrigin,
			msgRequest: this.msgRequest,
			quoteContext: ctx,    // forward full context for completeness
			// Tag source so the Quote Analytics dashboard knows this quote came
			// from the tape-chart-wiki flow (calendar drag/pick).
			source: QuoteSource.TAPE_CHART
		};
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(QuoteComponent, dialogConfig);
    dialogRef.componentInstance.doEmailEvent.subscribe(
      data => {
        // Intentionally NOT re-emitting to the parent (inbox).
        // Bubbling doEmailEvent caused the inbox to close the entire tape chart
        // dialog immediately after a quote was sent — the rep lost context and
        // could not send quotes for remaining date-range dialogs.
        // The quote dialog already shows its own success toast and closes itself
        // via doAdd below; no further action needed here.
        console.log('doEmailEvent Tape Chart output (not propagated):', data);
      });
    dialogRef.componentInstance.doAdd.subscribe(
      (payload: any) => {
        // payload is { message, quoteId } — email is sent async so show info toast
        // now and poll ~5 s later to catch any delivery failure.
        const message = typeof payload === 'string' ? payload : payload?.message;
        const quoteId = typeof payload === 'string' ? null  : payload?.quoteId;
        dialogRef.close();
        this.messageService.add({ severity: 'info', summary: '📨 Quote Saved', detail: message, life: 8000 });
        if (quoteId) {
          setTimeout(() => {
            this.quoteService.getEmailStatus(quoteId).subscribe((res: any) => {
              if (res?.data?.emailStatus?.emailSendStatus === 4) {
                const errorDetail = res?.data?.emailStatus?.emailSendStatusMsg
                  || 'The email could not be delivered to the guest.';
                this.messageService.add({
                  severity: 'error', summary: '⚠️ Email Delivery Failed',
                  detail: errorDetail, life: 0
                });
              }
            });
          }, 5000);
        }
      });
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);
				if(data)
					{
					this.selectedProperties = [...data];
					let selectedPropertys = [];
					data.forEach(property => {
						selectedPropertys.push(property.propertyCode)
					});
					this.showPropertyQuoteBtn = true;
					this.tapeChartsByProperty.forEach(property => {
						if(selectedPropertys.includes(property.propertyCode))
						{
							property.isSelected = true;
						}
						else
						{
							property.isSelected = false;
							this.selectAllProperties = false;
						}
					});
				}
				// close the dialogBox
				// dialogRef.close();
			});
		return dialogRef;
	}

	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-tapeChart-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'analyzedDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.tapeChartWikiService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.tapeCharts = res.data.rates;
						this.buildColumns();
						this.buildRows();
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.tapeCharts = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	buildColumns() {
		this.scrollingColumns = [];
		this.monthNameColumns = [];
		this.frozenColumns = [];

		this.frozenColumns = [
		  { field: 'propertyCode', header: 'Property' },
		  { field: 'addressDevelopmentName', header: 'Development' },
		  { field: 'bedrooms', header: 'Bedrooms' }
		];

		if(this.tapeCharts && this.tapeCharts.length > 0)
		{
			let totalDaysInMonth = 0;
			let searchedStartDate = new Date(this.currentSearchForm.startDate);
			let searchedEndDate = new Date(this.currentSearchForm.endDate);
			if(this.searchWithLosNights == null || this.searchWithLosNights == '0'
				|| this.selectedRateOption == null || this.selectedRateOption != 'los')
			{
				searchedStartDate.setDate( this.currentSearchForm.startDate.getDate() - 10 );
				searchedEndDate.setDate( this.currentSearchForm.endDate.getDate() + 10 );
			}
			else
			{
				//We do not search rate for checkout date hence not creating column of checkout date
				searchedEndDate.setDate( this.currentSearchForm.endDate.getDate() - 1 );
			}

			let prevMonth = new Date(searchedStartDate.getTime());
			for (let d = searchedStartDate; d <= searchedEndDate; d.setDate(d.getDate() + 1))
			{
				let startYear = d.getFullYear();
				let startMonth = d.getMonth();
				let startDate = d.getDate();
				let updatedStartMonth = '' + startMonth;
				if (startMonth < 9)
				{
					updatedStartMonth = '0' + (startMonth + 1);
				}
				else
				{
					updatedStartMonth = '' + (startMonth + 1);
				}
				let updatedStartDate = '' + startDate;
				if (startDate <= 9)
				{
					updatedStartDate = '0' + startDate;
				}
				let updatedFullDate = startYear + '-' + updatedStartMonth + '-' + updatedStartDate;

				// Date columns
				this.scrollingColumns.push({
					field: updatedFullDate, header: new DatePipe('en-US').transform(d, 'MM-dd-yy EEE')
				});

				 // Month name column to show on top of date
				 let currMonth = d;
				 if (prevMonth.getMonth() != currMonth.getMonth())
				 {
				   this.monthNameColumns.push({month: prevMonth, days: totalDaysInMonth});
				   prevMonth = new Date(currMonth);
				   totalDaysInMonth = 1;
				 }
				 else
				 {
				   totalDaysInMonth = totalDaysInMonth + 1;
				 }
			}
			// Add this month as we are only adding previous months in above loop
			this.monthNameColumns.push({month: prevMonth, days: totalDaysInMonth});
			console.log(this.monthNameColumns);
		}
	}

	buildRows() {
		this.tapeChartsByProperty = [];
		// Group all by property code
		let map = new Map();
		for (let index = 0; index < this.tapeCharts?.length; index++)
		{
			if (map.get(this.tapeCharts[index].propertyCode)) {
				this.tapeCharts[index].isDateMatched = false; // Set default to false and set it true in matchHeaderDate method
				let tapeChartRowsByProperty = map.get(this.tapeCharts[index].propertyCode);
				tapeChartRowsByProperty.push(this.tapeCharts[index]);
				map.set(this.tapeCharts[index].propertyCode, tapeChartRowsByProperty);
			} else {
				let tapeChartRowsByProperty = [];
				this.tapeCharts[index].isDateMatched = false; // Set default to false and set it true in matchHeaderDate method
				tapeChartRowsByProperty.push(this.tapeCharts[index]);
				map.set(this.tapeCharts[index].propertyCode, tapeChartRowsByProperty);
			}
		}
		map.forEach((value: any, key: string) => {
			let property = {
				propertyCode: key,
				addressDevelopmentName: value[0]?.addressDevelopmentName,
				bedrooms: value[0]?.bedrooms,
				bathrooms: value[0]?.bathrooms,
				viewType:  value[0]?.viewType,
				listingStatus: value[0]?.listingStatus,
				shortTermRentalId: value[0]?.shortTermRentalId,
				rates: value
			};
			this.tapeChartsByProperty.push(property);
		});
		console.log('Building rows finished');
		this.tapeChartsByProperty.forEach(property => {
			let ratesWithAllDate = [];
			this.scrollingColumns.forEach(column => {
				this.matchHeaderDate(property, column.field, ratesWithAllDate);
			});
			property.rates = ratesWithAllDate;
		});
	}

	matchHeaderDate(rowData, analyzedDate, ratesWithAllDate) {
		let isMatchFound = false;
		let previousMatchedDate = null;
		rowData.rates.forEach(element => {
			if (!element.isDateMatched && element.analyzedDate == analyzedDate &&
				(previousMatchedDate == null || previousMatchedDate != analyzedDate)) {

				previousMatchedDate = analyzedDate; // to avoid duplicate date for same property
				element.isDateMatched = true;
				isMatchFound = true;

				// Calculate start date to show border on left side
				let startYear = this.currentSearchForm.startDate.getFullYear();
				let startMonth = this.currentSearchForm.startDate.getMonth();
				let startDate = this.currentSearchForm.startDate.getDate();
				let updatedStartMonth = '' + startMonth;
				if (startMonth < 9)
				{
					updatedStartMonth = '0' + (startMonth + 1);
				}
				else
				{
					updatedStartMonth = '' + (startMonth + 1);
				}
				let updatedStartDate = '' + startDate;
				if (startDate <= 9)
				{
					updatedStartDate = '0' + startDate;
				}
				let updatedFullDate = startYear + '-' + updatedStartMonth + '-' + updatedStartDate;
				if (updatedFullDate == analyzedDate)
				{
					element.isStartDate = true;
					this.startDateFound = true;
				}
				if (this.startDateFound)
				{
					element.showRateInformation = true;
				}

				// Calculate end date to show border on right side
				// Minus 1 day to exlcude checkout date in right border
				let endDateObj = new Date(this.currentSearchForm.endDate.getTime() - (24 * 60 * 60 * 1000));
				let endYear = endDateObj.getFullYear();
				let endMonth = endDateObj.getMonth();
				let endDate = endDateObj.getDate();
				let updatedEndMonth = '' + endMonth;
				if (endMonth < 9)
				{
					updatedEndMonth = '0' + (endMonth + 1);
				}
				else
				{
					updatedEndMonth = '' + (endMonth + 1);
				}
				let updatedEndDate = '' + endDate;
				if (endDate <= 9)
				{
					updatedEndDate = '0' + endDate;
				}
				let updatedFullEndDate = endYear + '-' + updatedEndMonth + '-' + updatedEndDate;
				if (updatedFullEndDate == analyzedDate)
				{
					element.isEndDate = true;
					this.startDateFound = false;
				}
				ratesWithAllDate.push(element);
				return;
			}
		});
		if (!isMatchFound)
		{
			let obj = {isDateMatched : false};
			ratesWithAllDate.push(obj);
		}
	}

	onSearchSubmit(searchForm: any) {
		this.checkInOutClickCount = 0; // reset on search
		// When in flex mode, capture any LOS (nights) change from the search bar filter.
		// This lets the reservationist update the night count (e.g. guest called and changed
		// from 4 to 5 nights) without leaving the tape chart view.
		if (this.quoteContext?.flexMode && searchForm.numNtsList?.length) {
			this.flexSelectedNights = [...searchForm.numNtsList];
			// Keep quoteContext in sync so runFlexFinder's guard passes;
			// use the first selected value as the canonical single-night fallback.
			this.quoteContext.flexNumNights = this.flexSelectedNights[0];
			this.recomputeFlexPreSetNights();
		}
		Object.assign(this.currentSearchForm, searchForm); // Just to avoid change of currentSearchForm when searchForm value changes, keeping separate object references for both:
		this.getTapeChartDetails(searchForm, null);
	}

	getTapeChartDetails(searchForm, sortField)
	{
	 try
	 {
	  if (searchForm.startDate && searchForm.endDate)
	  {
		  this.loading = true;
		  // First Reset everything
		  this.tapeChartsByProperty = [];
		  this.scrollingColumns = [];
		  this.monthNameColumns = [];
		  this.frozenColumns = [];
		  let reqForm: any = {};
		  Object.assign(reqForm, searchForm); // Just to avoid change of currentSearchForm when searchForm value changes, keeping separate object references for both:
		  reqForm.startDate = this.addTimeOffsetToLocalDateTime(searchForm.startDate);
		  reqForm.endDate = this.addTimeOffsetToLocalDateTime(searchForm.endDate);
		  reqForm.sortBy = sortField;
		  // Search rates with LOS table join or only availability from Rate table
		  reqForm.searchByRateLos = true;
		  if (this.selectedRateOption != null && this.selectedRateOption == 'los')
		  {
			reqForm.searchByRateLos = false;
		  }
		  // Default search for all Units
		  if (reqForm.showAvailableOnly == null)
		  {
			if (this.showAvailableOnly)
			{
				reqForm.showAvailableOnly = '1';
			}
			else
			{
				reqForm.showAvailableOnly = '0';
			}
		  }

		  // Search for individual nights if no night selected
		  if (reqForm.searchWithLosNights == null)
		  {
			reqForm.searchWithLosNights = this.searchWithLosNights;
		  }
		  // Do not search by search with los nights if Night is selected from toggle
		  if (reqForm.searchByRateLos)
		  {
			reqForm.searchWithLosNights = '0';
		  }

		  this.tapeChartWikiService.searchRateSummaries(reqForm)
			.subscribe(
			res =>
			{
				this.selectedProperties = [];
				// 03-12-2025 Divy: Reset quoteCheckInDate when user search dates again to start wiki quote with searched date
				this.quoteCheckInDate = null;

				this.tapeCharts = res.data.rates;
				this.buildColumns();
				this.buildRows();

				// Apply smart-parse context filter (resort + bedrooms) —
				// hides rows that don't match what the guest asked for.
				this.applyContextFilter();

				this.loading = false;
				// Signal BestFitListComponent that the tape chart data is ready.
				// flexSearching was set to true when the context was applied;
				// clearing it here lets the child component stop its loading
				// spinner and begin its own window scan via ngOnChanges.
				this.flexSearching = false;
			},
			err =>
			{
				this.loading = false;
				this.flexSearching = false;   // unblock child spinner on error too
				console.log('searchRateSummaries FAIL: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
			},
			() => { this.loading = false; });
	  }

	} catch (error)
	{
	this.alertService.error(error);
	}
  }

// Toggle between show only Available properies or all properies
  showAvailableOnlyChange()
  {
	if (this.showAvailableOnly)
	{
		this.currentSearchForm['showAvailableOnly'] = '1';
	}
	else
	{
		this.currentSearchForm['showAvailableOnly'] = '0';
	}
	this.getTapeChartDetails(this.currentSearchForm, null);
  }

	setInnerWidthHeightParameters()
	{
		this.innerWidth = window.innerWidth;
		this.innerHeight = window.innerHeight * 0.70;
	}

	getStatus() {
		return;
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data, null);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(tapeChart: TapeChart) {
		try {
			this.loading = true;
			this.tapeChartWikiService.update(tapeChart)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.tapeCharts.map((tapeChart, i) => {
							if (tapeChart.rateId === res.data.tapeChart.rateId) {
								this.tapeCharts[i] = res.data.tapeChart;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.loading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(tapeChart: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(tapeChart));

			this.loading = true;
			this.tapeChartWikiService.delete(tapeChart.rateId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.tapeCharts.splice(this.tapeCharts.indexOf(tapeChart), 1);
						this.recordTotal = this.tapeCharts.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'TapeChart ' + tapeChart.rateId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'TapeChart ' + tapeChart.rateId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.loading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add TapeChart'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TapeChartWikiComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(tapeChart: any, analyzedDate: any) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			tapeChart: tapeChart,
			title: 'Edit ',
			analyzedDate: analyzedDate
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(TapeChartWikiComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteTapeChartCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addTapeChartCB(tapeChart: TapeChart) {
		console.log('Adding TapeChart: ' + JSON.stringify(tapeChart));
		// if we don't have a tapeCharts array yet...
		if (!this.tapeCharts) {
			this.tapeCharts = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.tapeCharts.unshift(tapeChart);

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Added', life: 3000 });
	}

	updateTapeChartCB(tapeChart: TapeChart) {
		console.log('Updating TapeChart: ' + JSON.stringify(tapeChart));
		let itemIndex = this.tapeCharts.findIndex((item: any) => item.rateId === tapeChart.rateId);
		this.tapeCharts[itemIndex] = tapeChart;

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Updated', life: 3000 });
	}

	deleteTapeChartCB(tapeChart: TapeChart) {
		console.log('Removing TapeChart: ' + tapeChart);
		this.tapeCharts.splice(this.tapeCharts.indexOf(tapeChart), 1);
		this.recordTotal = this.tapeCharts.length;

		// no idea what this is but it is required to update the array
		this.tapeCharts = [...this.tapeCharts];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'TapeChart ' + tapeChart.rateId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.tapeCharts ? this.first === (this.tapeCharts.length - this.rows) : true; }
	isFirstPage(): boolean { return this.tapeCharts ? this.first === 0 : true; }

	getStatusName(tapeChart: any) {
		if (tapeChart?.status) {
			const status = this.statuses.find((e: any) => e.value == tapeChart.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	// Redirect to bulk update component and pass selected rate object to show default selected values
	onGoToBulkUpdate(rate: any) {
		this.doRedirectBulkUpdateCB.emit(rate);
	}

	showPaginator()
	{
		return true;
	}

	editRateDetails(rate, analyzedDate) {
		// Open only if not reserved as we are showing reservation details page for reserved day
		if (!rate.reservationId)
		{
			this.onOpenFormEdit(rate, analyzedDate);
		}
	}

calcMinListPrice(advertisedRate: any)
  {

    let response: any = {};
    let systemFloorRate = [];

    /*
    Calc the lowest allowed rate, if any set by manager, owner, or global
    */

    // calc lowest by Manager
    systemFloorRate.push(advertisedRate.floorRateManagerAMT ? advertisedRate.floorRateManagerAMT : 0);

    // calc lowest by Owner
    systemFloorRate.push(advertisedRate.floorRateOwnerAMT ? advertisedRate.floorRateOwnerAMT : 0);

    // calc lowest by global minNightly
    systemFloorRate.push(advertisedRate.minNightlyRate ? advertisedRate.minNightlyRate : 0);

    // calc lowest by rack or discounter
    let minAdRate = (this.calcPropertyListPrice(advertisedRate) -
      (+this.calcPropertyListPrice(advertisedRate) * (advertisedRate.maxDiscountPCT ? advertisedRate.maxDiscountPCT : 0)));


    let minSystemRate = Math.max(...systemFloorRate);


    // if we have a artificially high floor,
    if (minSystemRate > minAdRate)
    {
      response.rate = minSystemRate;
      response.color = '#FFA500';
    }
    else
    {
      response.rate = minSystemRate;
      response.color = 'transparent';
    }

    return response;

  }

  openMaintenanceProperty(rate)
  {
	this.reservationService.findMaintenanceEventByShortTermRentalIdAndanalyzeDate(rate.shortTermRentalId, rate.analyzedDate)
		.pipe(first())
		.subscribe(
			res => {
				console.log('findMaintenanceEvent: ' + JSON.stringify(res));
				this.onOpenMaintenanceEventPopUp(res.data.maintenanceEvent);
			},
			err => {
				console.log('error In findMaintenanceEvent is: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your MaintenanceEvent: ' + err.message, sticky: true });
			},
			() => {  });
  }

  /*********
		* Edit Button
		*
		*/
	onOpenMaintenanceEventPopUp(maintenanceEventList: MaintenanceEvent[]) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '40vw';
			dialogConfig.width = '25vw';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			maintenanceEventList: maintenanceEventList,
			title: 'Edit MaintenanceEvent'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(MaintenanceEventComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database

				// close the dialogBox
				dialogRef.close();
			});
	}

  findReservationById(rate: any) {
	this.reservationService.findById(rate.reservationId)
		.pipe(first())
		.subscribe(
			res => {
				console.log('findReservationById: ' + JSON.stringify(res));
				this.reservation = res.data.reservation;
				this.openPopUpReservation(this.reservation);

			},
			err => {
				console.log('error In findReservationById is: ' + JSON.stringify(err));
				this.messageService.add({ severity: 'error', summary: 'Error', detail: 'We were unable to retrieve your reservation: ' + err.message, sticky: true });
			},
			() => {  });
}

	openNewReservationWindow(rates: any, index: any)
	{
		let searchedStartDate = new Date(this.currentSearchForm.startDate);
		let searchedEndDate = new Date(this.currentSearchForm.endDate);

		// Find number of nights from start date to end date
		let numNights = Math.floor((Date.UTC(searchedEndDate.getFullYear(), searchedEndDate.getMonth(), searchedEndDate.getDate()) - Date.UTC(searchedStartDate.getFullYear(), searchedStartDate.getMonth(), searchedStartDate.getDate()) ) / (1000 * 60 * 60 * 24));
		let isAllNightOpen = true;
		for (let i = 0; i < numNights; i++)
		{
			if (rates[index + i].reservationId != null)
			{
				isAllNightOpen = false;
				this.shortTermRentalBeforeWarning = rates[index].shortTermRentalId;
				this.checkInBeforeWarning = rates[index].analyzedDate;
				this.checkOutBeforeWarning = rates[index + i].analyzedDate;
				this.warningMessage = 'Only ' + i + ' night[s] are available from ' + this.datePipe.transform(this.checkInBeforeWarning, 'MM-dd-yyyy') + ' to ' + this.datePipe.transform(this.checkOutBeforeWarning, 'MM-dd-yyyy');
				this.showReservationWarning = true;
				break;
			}
		}
		if (isAllNightOpen)
		{
			this.shortTermRentalBeforeWarning = null;
			this.checkInBeforeWarning = null;
			this.checkOutBeforeWarning = null;
			this.openCreateReservationPopUp(rates[index].shortTermRentalId, rates[index].analyzedDate, rates[index + numNights].analyzedDate, 2, 0);
			console.log('All nights are Open');
		}
	}

	fetchRateLogOutput(rate: any, propertyCode: any)
	{
		this.selectedRateForOpsNotes = rate;
		this.fetchOpsNotes(rate, propertyCode);
		this.fetchRateFees(rate, propertyCode);
	}

	openPromoLog(reservationId: any, shortTermRentalId?: any, checkInDate?: any, checkOutDate?: any)
	{
		this.promoLogAlerts = [];
		this.promoLogLoading = true;
		this.promoLogReservationId = reservationId || ('STR#' + shortTermRentalId + ' [DRY RUN]');
		this.showPromoLogDialog = true;

		const handleResponse = (res: any) => {
			const appStatus = res?.data?.appStatus;
			const alerts: any[] = [];
			if (appStatus?.alertCollection) { alerts.push(...appStatus.alertCollection); }
			if (appStatus?.errorCollection) { alerts.push(...appStatus.errorCollection); }
			this.promoLogAlerts = alerts;
			this.promoLogLoading = false;
		};
		const handleError = (err: any) => {
			this.promoLogLoading = false;
			console.log('openPromoLog FAIL: ' + JSON.stringify(err));
			this.messageService.add({ severity: 'error', summary: 'Failed to load promotion log', life: 3000 });
		};

		if (reservationId) {
			this.tapeChartWikiService.getPromotionLog(reservationId).subscribe(handleResponse, handleError);
		} else {
			// No reservation yet — dry run.
			// Use promoLogCheckInDate/CheckOutDate captured in fetchOpsNotes with local
			// timezone formatting (no UTC shift). Fall back to passed params if set.
			const ci = checkInDate  || this.promoLogCheckInDate;
			const co = checkOutDate || this.promoLogCheckOutDate;
			console.log('openPromoLog DRY RUN: STR=' + shortTermRentalId + ' checkIn=' + ci + ' checkOut=' + co);
			this.tapeChartWikiService.getPromotionLogDryRun(shortTermRentalId, ci, co).subscribe(handleResponse, handleError);
		}
	}

	fetchRateFees(rate: any, propertyCode: any)
	{
		this.opsNoteDetails = [];
		if (rate.shortTermRentalId)
		{
			try {
				this.showOpsNoteDialog = true;
				// this.orderDetailService.findNightlyRateFeesOpsNotesDetails(rate.shortTermRentalId, rate.numNights)
				this.orderDetailService.findNightlyRateFeesOpsNotesDetails(rate.shortTermRentalId, rate.numNights)
					.subscribe(
						(res: any) => {
							console.log('fetchRateFees SUCCESS: ' + JSON.stringify(res));
							this.rateFeesDetails = res.data.addToRateQuote?.orderDetails;
							console.log(this.rateFeesDetails);
						},
						(err: any) => {
							this.loading = false;
							console.log('fetchRateFees FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.loading = false; });
			} catch (error) {
				this.loading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
	}

	fetchOpsNotes(rate: any, propertyCode: any)
	{
		this.opsNoteDetails = [];
		if (rate.shortTermRentalId)
		{
			try {
				let startDateStr = null;
				let endDateStr = null;
				// 02-26-2025 Divy : If LOS is selected with Nights from dropdown
				if (this.selectedRateOption && this.selectedRateOption == 'los'
					&& this.searchWithLosNights && this.searchWithLosNights != '0')
				{
					if (rate.checkInDate && rate.checkOutDate)
					{
						startDateStr = rate.checkInDate;
						endDateStr = rate.checkOutDate;
					}
					// LOS path: dates are already plain YYYY-MM-DD strings from the API
					this.promoLogCheckInDate  = startDateStr;
					this.promoLogCheckOutDate = endDateStr;
				}
				else
				{
					// 02-26-2025 Divy : If DATES is selected then search with start and end date
					let searchedStartDate = new Date(this.currentSearchForm.startDate);
					let searchedEndDate = new Date(this.currentSearchForm.endDate);
					if (searchedStartDate != null && searchedEndDate)
					{
						// Capture raw local-calendar dates BEFORE addLocalTimeToDateTime transforms
						// them into UTC-midnight, so IST/CDT offsets don't shift the calendar date.
						this.promoLogCheckInDate  = moment(searchedStartDate).format('YYYY-MM-DD');
						this.promoLogCheckOutDate = moment(searchedEndDate).format('YYYY-MM-DD');
						searchedStartDate = this.addLocalTimeToDateTime(searchedStartDate);
						searchedEndDate = this.addLocalTimeToDateTime(searchedEndDate);
						startDateStr = moment.utc(new Date(searchedStartDate)).format('YYYY-MM-DD');
						endDateStr = moment.utc(new Date(searchedEndDate)).format('YYYY-MM-DD');
					}
				}

				this.showOpsNoteDialog = true;
				let opsRequest = {
					'shortTermRentalId' : rate.shortTermRentalId,
					'checkInDate' : startDateStr,
					'checkOutDate' : endDateStr
				};

				this.orderDetailService.findNightlyRateOpsNotesDetails(opsRequest)
					.subscribe(
						(res: any) => {
							console.log('findNightlyRateOpsNotesDetails SUCCESS: ' + JSON.stringify(res));
							// this.opsNoteDetails = res.data.rateLos?.opsNotes;
							this.tapeChartsByProperty.forEach(property => {
								if (property.propertyCode == propertyCode)
								{
								  if (res?.data?.rateLos?.logOutput) {

										let logOutput: any = '[' + res?.data?.rateLos?.logOutput.replaceAll(/\n\n/g, ',') + ']';
										logOutput = JSON.parse(logOutput);
										const logData = [];
										logOutput.forEach(group => {
										logData.push(...group);
										logData.push({ isBlankRow: true }); // Add blank row
										});
										logOutput = logData;
										res.data.rateLos.logOutput = logOutput;
									}
									if (res?.data?.rateLos?.opsNotes) {
										let opsNotes: any = '[' + res?.data?.rateLos?.opsNotes.replaceAll(/\n\n/g, ',').replaceAll(/\]\[/g, '],[ ') + ']';
										opsNotes = JSON.parse(opsNotes);
										const logData = [];
										opsNotes.forEach(group => {
										logData.push(...group);
										logData.push({ isBlankRow: true }); // Add blank row
										});
										opsNotes = logData;
										res.data.rateLos.opsNotes = opsNotes;
									}
									this.opsNoteDetails.push(res?.data?.rateLos);
									return;
								}
							});
							// this.alertService.success(res, true);
							// this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						},
						(err: any) => {
							this.loading = false;
							console.log('findNightlyRateOpsNotesDetails FAIL: ' + JSON.stringify(err));
							this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
						},
						() => { this.loading = false; });
			} catch (error) {
				this.loading = false;
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}



	}

	fetchCurrentRateQuoteWithAdjustments(opsNoteDetail)
	{
		let checkInDate = opsNoteDetail.checkInDate;
		let checkOutDate = opsNoteDetail.checkOutDate;
		if (checkInDate == null)
		{
			checkInDate = moment.utc(this.currentSearchForm.startDate).format('YYYY-MM-DD');
		}

		if (checkOutDate == null)
		{
			// End date creates timezone issue hence using this method to remove timezone
			let searchedEndDate = this.addLocalTimeToDateTime(this.currentSearchForm.endDate);
			checkOutDate = moment.utc(searchedEndDate).format('YYYY-MM-DD');
		}

		try {
			this.loading = true;
			this.showOpsNoteDialog = true;
			let opsRequest = {
				'shortTermRentalId' : opsNoteDetail.extPropertyId,
				'checkInDate' : checkInDate,
				'checkOutDate' : checkOutDate
			};

			this.ymReservationService.fetchReservationQuoteWithAdjustments(opsRequest)
				.subscribe(
					(res: any) => {
						console.log('fetchReservationQuoteWithAdjustments SUCCESS: ' + JSON.stringify(res));
						this.loading = false;
						let quoteApi = res.data.quoteApi;
						if (quoteApi.opsNotes) {
							let opsNotes: any = '[' + quoteApi.opsNotes.replaceAll(/\n\n/g, ',').replaceAll(/\]\[/g, ', ') + ']';
							opsNotes = JSON.parse(opsNotes);
							const logData = [];
							opsNotes.forEach(group => {
							logData.push(...group);
							logData.push({ isBlankRow: true }); // Add blank row
							});
							opsNotes = logData;
							this.opsNoteDetails[0].opsNotes = opsNotes;
						}
					},
					(err: any) => {
						this.loading = false;
						console.log('fetchReservationQuoteWithAdjustments FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.loading = false; });
		} catch (error) {
			this.loading = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/**
	 * Click-to-pick handler on an available cell. First click stashes the date + property;
	 * second click on a different cell in the same property opens the Create Reservation
	 * dialog pre-filled with check-in / check-out. Clicks on inner controls (price, Q,
	 * info icon, maintenance) are ignored so their own handlers run as before.
	 */
	onAvailableCellClick(rowData: any, rate: any, event: MouseEvent): void {
		// Ignore reserved cells — only available (greenable) cells participate.
		if (rate.reservationId) return;
		if (!rate.isDateMatched) return;
		// Let inner clickables (price, Q, info icon) handle their own click.
		const target = event.target as HTMLElement;
		if (target.closest('a, button, i.pi-info-circle, .maintenance-indicator')) return;

		// First click — stash and visually mark.
		if (!this.pickedStartCell) {
			rate.isPickedStart = true;
			this.pickedStartCell = { rowData, rate, date: rate.analyzedDate };
			return;
		}

		// Second click on a different property — treat as a fresh first click.
		if (this.pickedStartCell.rowData.propertyCode !== rowData.propertyCode) {
			this.clearPickedStartCell();
			rate.isPickedStart = true;
			this.pickedStartCell = { rowData, rate, date: rate.analyzedDate };
			return;
		}

		// Same cell clicked twice — cancel.
		if (this.pickedStartCell.date === rate.analyzedDate) {
			this.clearPickedStartCell();
			return;
		}

		// Same property, different date — order them and open the dialog.
		const firstDate = this.pickedStartCell.date;
		const secondDate = rate.analyzedDate;
		const checkInDate = firstDate <= secondDate ? firstDate : secondDate;
		const checkOutDate = firstDate <= secondDate ? secondDate : firstDate;

		this.clearPickedStartCell();
		this.openCreateReservationPopUp(rowData.shortTermRentalId, checkInDate, checkOutDate, 2, 0);
	}

	private clearPickedStartCell(): void {
		if (this.pickedStartCell) {
			this.pickedStartCell.rate.isPickedStart = false;
			this.pickedStartCell = null;
		}
	}

	openCreateReservationPopUp(shortTermRentalId: any, checkInDate: any, checkOutDate: any, numAdults: any, numChildren: any) {
		const dialogConfig = new MatDialogConfig();

		const data = {
			checkInDate: moment.utc(new Date(checkInDate)).format('MM/DD/YYYY'),
			checkOutDate: moment.utc(new Date(checkOutDate)).format('MM/DD/YYYY'),
			shortTermRentalId: shortTermRentalId,
			numAdults: numAdults,
			numChildren: numChildren
		};
		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = '40vw';
		dialogConfig.width = '20vw';
		dialogConfig.disableClose = true;
		dialogConfig.data = {
			showCloseButton: true,
			reservation: data,
			openNewTab: true
		};
		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationCreateComponent, dialogConfig);
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				dialogRef.close();
			});
	}

	onConfirmReservationWarning()
	{
		this.showReservationWarning = false;
		this.openCreateReservationPopUp(this.shortTermRentalBeforeWarning, this.checkInBeforeWarning, this.checkOutBeforeWarning, 2, 0);
	}

  openPopUpReservation(reservation: any)
  {
	const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
    	dialogConfig.maxWidth = '100vw';
		dialogConfig.width = '95vw';
      	dialogConfig.maxHeight = '50vw';
		dialogConfig.height = '41vw';

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			reservation: reservation,
      		showCloseButton: true,
			title: 'Edit Order',
			isPopup: true
		};
		const dialogRef = this.dialog.open(OrderComponent, dialogConfig);
		// this.router.navigate(['/reservations-edit', rate.reservationId]);
  }

  calcPropertyListPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAdjustAMT)
    {
      return +this.formatPercent(advertisedRate.listPriceAdjustAMT);
    }
    else
    {
      return this.calcListPrice(advertisedRate);
    }
  }

//   calcPropertyListPrice(advertisedRate: any)
//   {
//     if (advertisedRate && advertisedRate.rateBucketAdjustmentPct)
//     {
//       return this.calcListPrice(advertisedRate) + (this.calcListPrice(advertisedRate) * advertisedRate.rateBucketAdjustmentPct)
//     }
//     else
//     {
//       return this.calcListPrice(advertisedRate);
//     }
//   }

  calcListPrice(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAMT)
    {
      return +this.formatPercent(advertisedRate.listPriceAMT);
    }
  }

  calcYielPrice(advertisedRate: any)
  {
    if (advertisedRate)
    {
		if (advertisedRate.yieldPriceAMT)
		{
			return +this.formatPercent(advertisedRate.yieldPriceAMT);
		}
		// If yieldPriceAMT not available (because we delete los when day is reserved)
		// then use yieldprice form Rate
		else if (advertisedRate.rateYieldPriceAMT)
		{
			return +this.formatPercent(advertisedRate.rateYieldPriceAMT);
		}
    }
  }

  calcCouponYielPrice(advertisedRate: any)
  {
    if (advertisedRate)
    {

		if (advertisedRate.rateAfterCouponAmt)
		{
			return +this.formatPercent(advertisedRate.rateAfterCouponAmt);
		}
		else if (advertisedRate.yieldPriceAMT)
		{
			return +this.formatPercent(advertisedRate.yieldPriceAMT);
		}
		// If yieldPriceAMT not available (because we delete los when day is reserved)
		// then use yieldprice form Rate
		else if (advertisedRate.rateYieldPriceAMT)
		{
			return +this.formatPercent(advertisedRate.rateYieldPriceAMT);
		}
    }
  }

  calcAmtFromListPriceAdjustPCT(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAdjustPCT)
    {
		let propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
		return propertyListPrice + (propertyListPrice * advertisedRate.listPriceAdjustPCT);
    }
  }

  calcAmtFromRateBucketAdjustmentPct(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.rateBucketAdjustmentPct)
    {
		let propertyListPrice = +this.calcAmtFromListPriceAdjustPCT(advertisedRate);
		if (!propertyListPrice)
		{
			propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
		}
		return propertyListPrice + (propertyListPrice * advertisedRate.rateBucketAdjustmentPct);
    }
  }

  calcAmtFromMaxDiscountPCT(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.maxDiscountPCT)
    {
		let maxFloorAmount: number = advertisedRate.listPriceAMT;
		if (advertisedRate && advertisedRate.listPriceAdjustAMT)
		{
			maxFloorAmount = advertisedRate.listPriceAdjustAMT;
		}
		if (advertisedRate && advertisedRate.listPriceAdjustPCT)
		{
			maxFloorAmount = maxFloorAmount + (maxFloorAmount * advertisedRate.listPriceAdjustPCT);
		}
		if (advertisedRate && advertisedRate.rateBucketAdjustmentPct)
		{
			maxFloorAmount = maxFloorAmount + (maxFloorAmount * advertisedRate.rateBucketAdjustmentPct);
		}
		if (advertisedRate.floorRateOwnerAMT > maxFloorAmount)
		{
			return advertisedRate.floorRateOwnerAMT + (advertisedRate.floorRateOwnerAMT * advertisedRate.maxDiscountPCT);
		}
		else if (advertisedRate.minNightlyRate > maxFloorAmount)
		{
			return advertisedRate.minNightlyRate + (advertisedRate.minNightlyRate * advertisedRate.maxDiscountPCT);
		}
		else if (advertisedRate.floorRateManagerAMT > maxFloorAmount)
		{
			return advertisedRate.floorRateManagerAMT + (advertisedRate.floorRateManagerAMT * advertisedRate.maxDiscountPCT);
		}
		else
		{
			return maxFloorAmount + (maxFloorAmount * advertisedRate.maxDiscountPCT);
		}
    }
  }

  calcListPriceAdjPct(advertisedRate: any)
  {
    if (advertisedRate && advertisedRate.listPriceAdjustPCT)
    {
      let propertyListPrice = +this.calcPropertyListPrice(advertisedRate);
      return propertyListPrice + (propertyListPrice * advertisedRate.listPriceAdjustPCT);
    }
  }

  formatPercent(numPercent: string)
  {
    return parseFloat(numPercent).toFixed(2);
  }

  calcYMDiscFloorPrice(advertisedRate: any)
  {
    // if we have a discounting algorithm
    if (advertisedRate && advertisedRate.discountLookForwardDays && advertisedRate.discountLookForwardDays > 0 && advertisedRate.maxDiscountPCT && advertisedRate.maxDiscountPCT > 0)
    {
      let floor = 0.00;

      // calculate the lowest by the yield manager
      floor = +this.calcPropertyListPrice(advertisedRate) - (+this.calcPropertyListPrice(advertisedRate) * advertisedRate.maxDiscountPCT);

      if (advertisedRate.floorRateManagerAMT && advertisedRate.floorRateManagerAMT > 0)
      {
        if (floor > advertisedRate.floorRateManagerAMT)
        {
          return floor;
        }
        else
        {
          return advertisedRate.floorRateManagerAMT;
        }
      }
      else if (advertisedRate.floorRateOwnerAMT && advertisedRate.floorRateOwnerAMT > 0)
      {
        if (floor > advertisedRate.floorRateOwnerAMT)
        {
          return floor;
        }
        else
        {
          return advertisedRate.floorRateOwnerAMT;
        }
      }
      else
      {
        return floor;
      }
    }
    else
    {
      return +this.calcPropertyListPrice(advertisedRate);
    }
  }

  /**
   * Redirect to Property page on YM filtered by current dialog property
   * @param opsNoteDetail
   * @param defaultTabIndx
   */
  redirectToProperty(opsNoteDetail: any, defaultTabIndx: any)
  {
	let baseUrl = '/property-config/' + opsNoteDetail.propertyId;
	if (opsNoteDetail.rateBucketId)
	{
		baseUrl = baseUrl + '/' + opsNoteDetail.rateBucketId;
	}

	baseUrl = baseUrl + '/' + defaultTabIndx;
	// Rate Season
	if (defaultTabIndx == 4)
	{
		let checkInDate = opsNoteDetail.checkInDate;
		let checkOutDate = opsNoteDetail.checkOutDate;
		if (checkInDate == null)
		{
			checkInDate = moment.utc(this.currentSearchForm.startDate).format('YYYY-MM-DD');
		}

		if (checkOutDate == null)
		{
			// End date creates timezone issue hence using this method to remove timezone
			let searchedEndDate = this.addLocalTimeToDateTime(this.currentSearchForm.endDate);
			checkOutDate = moment.utc(searchedEndDate).format('YYYY-MM-DD');
		}
		baseUrl = baseUrl + '/' + checkInDate + '/' + checkOutDate;
	}

	const url = this.router.serializeUrl(
		this.router.createUrlTree([baseUrl])
	  );
	  window.open(url, '_blank');
  }

  openQuoteWindow(rates: any, index: any)
  {
	this.quote = null;
	this.formError = null;

	// If check In date is null, initialize with searched start and end dates
	if (!this.quoteCheckInDate)
	{
		this.quoteCheckInDate = new Date(this.currentSearchForm.startDate);
		let searchedEndDate = new Date(this.currentSearchForm.endDate);
		// Get the time difference in milliseconds
		let timeDifference = searchedEndDate.getTime() - this.quoteCheckInDate.getTime();

		// Convert the time difference from milliseconds to days
		let daysDifference = timeDifference / (1000 * 3600 * 24);

		// Nearest whole number if you need an integer
		daysDifference = Math.floor(daysDifference);
		this.form1.patchValue({
			quoteNumNight: daysDifference
		});
	}
	else
	{
		this.quoteCheckInDate = rates[index].analyzedDate;
	}

	this.quoteShortTermRentalId = rates[index].shortTermRentalId;
	this.quotePropertyCode = rates[index].propertyCode;
	this.form1.patchValue({
		checkInDate: this.addTimeOffsetToLocalDateTime(new Date(this.quoteCheckInDate)),
		shortTermRentalId: this.quoteShortTermRentalId,
		checkOutDate: '',
		numAdults: 2,
		numChildren: 0,
		numPets: '0',
		inquirerIpAddress: '',
		couponCode: ''
	});
	// Change checkout date to CheckIn date + Number of nights
	if (this.form1.get('checkInDate').value)
	{
		this.quoteMinCheckOutDate = this.form1.get('checkInDate').value;
		let quoteCheckOutDate = new Date(this.quoteMinCheckOutDate);
		if (this.form1.get('quoteNumNight').value != null)
		{
			quoteCheckOutDate.setDate(quoteCheckOutDate.getDate() + this.form1.get('quoteNumNight').value);
			this.form1.patchValue({
				checkOutDate: quoteCheckOutDate
			});
			// If we have CheckIn, checkout dates then search quote and show
			this.getQuoteForSearchRates(this.form1);
		}
	}
	// this.openCreateQuotePopUp(rates[index].shortTermRentalId, rates[index].analyzedDate, rates[index+numNights].analyzedDate);
	this.showQuoteWindow = true;
  }

  onQuoteCheckInDateChange()
  {
	this.quoteMinCheckOutDate = this.form1.get('checkInDate').value;
	let quoteCheckOutDate = new Date(this.quoteMinCheckOutDate);
	if (this.form1.get('quoteNumNight').value != null)
	{
		quoteCheckOutDate.setDate(quoteCheckOutDate.getDate() + this.form1.get('quoteNumNight').value);
		this.form1.patchValue({
			checkOutDate: quoteCheckOutDate
		});
	}
	let days = this.calculateDiffDays(this.form1.get('checkInDate').value, this.form1.get('checkOutDate').value);
	if (days < 1)
	{
		this.isDateLessThanCheckinDate = true;
	}
  }

  onQuoteCheckOutDateChange()
  {
	let quoteCheckOutDate = this.form1.get('checkOutDate').value;
	if (quoteCheckOutDate != null && this.form1.get('checkInDate').value != null)
	{
		let days = this.calculateDiffDays(this.form1.get('checkInDate').value, quoteCheckOutDate);
		if (days < 1)
		{
			this.isDateLessThanCheckinDate = true;
		}
		this.form1.patchValue({
			quoteNumNight: days
		});
	}
  }

  calculateDiffDays(startDate: Date, endDate: Date){
		return Math.floor((Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate()) - Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate()) ) / (1000 * 60 * 60 * 24));
	}

  onNumNightChange(val)
  {
	this.form1.patchValue({
		quoteNumNight: val
	});
	// Change checkout date to CheckIn date + Number of nights
	if (this.form1.get('checkInDate').value)
	{
		this.quoteMinCheckOutDate = this.form1.get('checkInDate').value;
		let quoteCheckOutDate = new Date(this.quoteMinCheckOutDate);
		if (this.form1.get('quoteNumNight').value != null)
		{
			quoteCheckOutDate.setDate(quoteCheckOutDate.getDate() + this.form1.get('quoteNumNight').value);
			this.form1.patchValue({
				checkOutDate: quoteCheckOutDate
			});
		}
	}
  }

  onAnalyzedDateClick(analyzedDate)
  {
	this.checkInOutClickCount++;
	if (this.checkInOutClickCount > 0 && this.checkInOutClickCount % 2 == 0)
	{
		this.searchedEndDate = this.addTimeOffsetToLocalDateTime(new Date(analyzedDate));
	}
	else
	{
		this.searchedStartDate = this.addTimeOffsetToLocalDateTime(new Date(analyzedDate));
	}
  }

  getQuoteForSearchRates(form1: UntypedFormGroup) {
	this.errorList = [];
	this.errorMessages = '';
	this.formError = null;
	try {
		let errors = this.getFormValidationErrors(this.form1);
		// Iterate errors list for check, if error is there it will store into errorList
		for (let i of errors) {
			if (i.control === 'checkInDate') {
				this.errorList.push('Arrival Date is Required');
			}
			if (i.control === 'checkOutDate') {
				this.errorList.push('Departure Date is Required');
			}
			if (i.control === 'numAdults') {
				this.errorList.push('Number of Adults is Required');
			}
			if (i.control === 'numChildren') {
				this.errorList.push('Number of Children is Required');
			}
		}
		if (this.errorList.length > 0) {
			for (let i = 0; i < this.errorList.length; i++) {
				this.errorMessages += this.errorList[i] + '<br>';
			}
			return;
		}
		// stop here if form is invalid
		if (this.form1.invalid) {
			return;
		}
		const formData = JSON.parse(JSON.stringify(this.form1.value));
		if (formData.checkInDate != 'undefined' && formData.checkInDate != null) {
			if (formData.checkInDate.includes('T')) {
				formData.checkInDate = moment(formData.checkInDate).format('YYYY-MM-DD');
			} else {
				let splitDateOfCheckInDate = formData.checkInDate.split('/');
				if (splitDateOfCheckInDate[0].length == 2) {
					let monthOfCheckInDate = splitDateOfCheckInDate[0];
					let dayOfCheckInDate = splitDateOfCheckInDate[1];
					let yearOfCheckInDate = splitDateOfCheckInDate[2];
					formData.checkInDate = yearOfCheckInDate + '-' + monthOfCheckInDate + '-' + dayOfCheckInDate;
				}
				if (splitDateOfCheckInDate[0].length == 4) {
					let yearOfCheckInDate = splitDateOfCheckInDate[0];
					let monthOfCheckInDate = splitDateOfCheckInDate[1];
					let dayOfCheckInDate = splitDateOfCheckInDate[2];
					formData.checkInDate = yearOfCheckInDate + '-' + monthOfCheckInDate + '-' + dayOfCheckInDate;
				}
			}
		} else {
			formData.checkInDate = '';
		}
		if (formData.checkOutDate != 'undefined' && formData.checkOutDate != null) {
			if (formData.checkOutDate.includes('T')) {
				formData.checkOutDate = moment(formData.checkOutDate).format('YYYY-MM-DD');
			} else {
				let splitDateOfCheckOutDate = formData.checkOutDate.split('/');
				if (splitDateOfCheckOutDate[0].length == 2) {
					let monthOfCheckOutDate = splitDateOfCheckOutDate[0];
					let dayOfCheckOutDate = splitDateOfCheckOutDate[1];
					let yearOfCheckOutDate = splitDateOfCheckOutDate[2];
					formData.checkOutDate = yearOfCheckOutDate + '-' + monthOfCheckOutDate + '-' + dayOfCheckOutDate;
				}
				if (splitDateOfCheckOutDate[0].length == 4) {
					let yearOfCheckOutDate = splitDateOfCheckOutDate[0];
					let monthOfCheckOutDate = splitDateOfCheckOutDate[1];
					let dayOfCheckOutDate = splitDateOfCheckOutDate[2];
					formData.checkOutDate = yearOfCheckOutDate + '-' + monthOfCheckOutDate + '-' + dayOfCheckOutDate;
				}
			}
		} else {
			formData.checkOutDate = '';
		}
		// this.myForm.patchValue({
		// 	checkInDate: formData.checkInDate,
		// 	checkOutDate: formData.checkOutDate,
		// 	numAdults: this.form1.value.numAdults,
		// 	numChildren: this.form1.value.numChildren,
		// 	couponCode: this.form1.value.couponCode,
		// 	shortTermRentalId: this.shortTermRental.shortTermRentalId
		// });

		this.submitted = true;
		this.isDateLessThanCheckinDate = false;
		this.searchButtonLabel = true;
		this.isSearching = true;

		this.reservationService.getQuote(formData)
			.subscribe(
				res => {
					this.isSearching = false;
					console.log('getQuote SUCCESS: ' + JSON.stringify(res));
					this.quote = res.data.quoteSummary.quoteApiList[0];
					sessionStorage.removeItem('quote');
					sessionStorage.setItem('quote', JSON.stringify(this.quote));
					if (this.checkCouponValidOrNot && !this.quote?.couponApplied){
						this.checkCouponValidOrNot = false;
						this.invalidCouponCode = true;
					}
					if (this.checkCouponValidOrNot && this.quote?.couponApplied){
						this.checkCouponValidOrNot = false;
						this.couponCodeSuccessMsg = true;
					}
					if (res.data.quoteSummary.quoteApiList[0].errors) {
						this.formError = res.data.quoteSummary.quoteApiList[0].errors[res.data.quoteSummary.quoteApiList[0].errors.length - 1];
					} else {
						// this.quoteService.saveCheckInDate(this.quote.checkInDate);
						// this.quoteService.saveCheckOutDate(this.quote.checkOutDate);
						// this.quoteService.saveNumAdults(this.quote.numAdults);
						// this.quoteService.saveNumChildren(this.quote.numChildren);

						// this.quoteService.setCheckInDate(this.quote.checkInDate);
						// this.quoteService.setCheckOutDate(this.quote.checkOutDate);
						// this.quoteService.setNumAdults(this.quote.numAdults);
						// this.quoteService.setNumChildren(this.quote.numChildren);
						// this.getQuoteBasedOnShortTermRental.emit(this.quote);
					}
				},
				err => {
					console.log('getQuote FAIL: ' + JSON.stringify(err));
					this.isSearching = false;
					this.formError = err.error;
					this.searchButtonLabel = false;
				},
				() => {
					this.isSearching = false;
					this.searchButtonLabel = false;
				});

	} catch (error) {
	}
}

compareDate(date: any) {
	this.isDateLessThanCheckinDate = false;
	let quoteCheckOutDate = this.form1.get('checkOutDate').value;
	if (quoteCheckOutDate != null && this.form1.get('checkInDate').value != null)
	{
		let days = this.calculateDiffDays(this.form1.get('checkInDate').value, quoteCheckOutDate);
		if (days < 1)
		{
			this.isDateLessThanCheckinDate = true;
		}
	}
}

getFormValidationErrors(form: any) {
	const result: { control: string; error: string; value: any; }[] = [];
	Object.keys(form.controls).forEach(key => {

		const controlErrors: ValidationErrors = form.get(key).errors;
		if (controlErrors) {

			form.get(key).markAsTouched();

			Object.keys(controlErrors).forEach(keyError => {
				result.push({
					control: key,
					error: keyError,
					value: controlErrors[keyError]
				});
			});
		}
	});
	return result;
}

  formBuild() {

	this.form1 = this.formBuilder.group({
		checkInDate: ['', Validators.required],
		checkOutDate: ['', Validators.required],
		shortTermRentalId: ['', Validators.required],
		quoteNumNight: [],
		numAdults: [2, Validators.required],
		numChildren: [0, Validators.required],
		numPets: ['0'],
		inquirerIpAddress: [''],
		couponCode: ['']
	});
	this.patchDates();
}

checkValidation(validationName: any) {
	if (validationName == 'checkInDate' && this.errorList.indexOf('Arrival Date is Required') !== -1) {
		this.updateValidation('Arrival Date is Required');
	}
	if (validationName == 'checkOutDate' && this.errorList.indexOf('Departure Date is Required') !== -1) {
		this.updateValidation('Departure Date is Required');
	}
	if (validationName == 'numAdults' && this.errorList.indexOf('Number of Adults is Required') !== -1) {
		this.updateValidation('Number of Adults is Required');
	}
	if (validationName == 'numChildren' && this.errorList.indexOf('Number of Children is Required') !== -1) {
		this.updateValidation('Number of Children is Required');
	}
}

updateValidation(validationMsg: any) {
	this.errorList.splice(this.errorList.indexOf(validationMsg), 1);
	if (this.errorList == null) {
		this.errorMessages = '';
	} else {
		this.errorMessages = '';
		for (let i = 0; i < this.errorList.length; i++) {
			this.errorMessages += this.errorList[i] + '<br>';
		}
	}
}

showCouponDialog(){
	this.couponCode = '';
	this.isSearching = false;
	this.invalidCouponCode = false;
	this.couponCodeSuccessMsg = false;
	this.isCouponCodeIsApply = false;
	this.checkCouponValidOrNot = false;
	this.showCoupon = true;
}

applyCouponCode(){
	this.isSearching = false;
	this.invalidCouponCode = false;
	this.couponCodeSuccessMsg = false;
	this.isCouponCodeIsApply = false;
	this.checkCouponValidOrNot = false;
	this.invalidCouponCode = false;
	this.couponCodeSuccessMsg = false;
	if (this.couponCode === '' || this.couponCode === null || this.couponCode === undefined){
		this.isCouponCodeIsApply = true;
	}else{
		this.checkCouponValidOrNot = true;
		this.form1.patchValue({
			couponCode: this.couponCode
		});
		this.getQuoteForSearchRates(this.form1.value);
	}
}

onBookNowClick() {
	let errors = this.getFormValidationErrors(this.form1);
	this.errorList = [];
	for (let i of errors) {
		console.log(i);

		if (i.control === 'checkInDate') {
			this.errorList.push('Arrival Date is required.');
		}
		if (i.control === 'checkOutDate') {
			this.errorList.push('Departure date is required.');
		}
		if (i.control === 'numAdults') {
			this.errorList.push('Number of adults is required.');
		}
		if (i.control === 'numChildren') {
			this.errorList.push('Number of children is required.');
		}
	}
	if (this.errorList.length > 0) {
		return;
	}
	const formData = JSON.parse(JSON.stringify(this.form1.value));
	if (formData.checkInDate != 'undefined' && formData.checkInDate != null) {
		if (formData.checkInDate.includes('T')) {
			formData.checkInDate = moment(formData.checkInDate).format('YYYY-MM-DD');
		} else {
			let splitDateOfCheckInDate = formData.checkInDate.split('/');
			if (splitDateOfCheckInDate[0].length == 2) {
				let monthOfCheckInDate = splitDateOfCheckInDate[0];
				let dayOfCheckInDate = splitDateOfCheckInDate[1];
				let yearOfCheckInDate = splitDateOfCheckInDate[2];
				formData.checkInDate = yearOfCheckInDate + '-' + monthOfCheckInDate + '-' + dayOfCheckInDate;
			}
			if (splitDateOfCheckInDate[0].length == 4) {
				let yearOfCheckInDate = splitDateOfCheckInDate[0];
				let monthOfCheckInDate = splitDateOfCheckInDate[1];
				let dayOfCheckInDate = splitDateOfCheckInDate[2];
				formData.checkInDate = yearOfCheckInDate + '-' + monthOfCheckInDate + '-' + dayOfCheckInDate;
			}
		}
	} else {
		formData.checkInDate = '';
	}
	if (formData.checkOutDate != 'undefined' && formData.checkOutDate != null) {
		if (formData.checkOutDate.includes('T')) {
			formData.checkOutDate = moment(formData.checkOutDate).format('YYYY-MM-DD');
		} else {
			let splitDateOfCheckOutDate = formData.checkOutDate.split('/');
			if (splitDateOfCheckOutDate[0].length == 2) {
				let monthOfCheckOutDate = splitDateOfCheckOutDate[0];
				let dayOfCheckOutDate = splitDateOfCheckOutDate[1];
				let yearOfCheckOutDate = splitDateOfCheckOutDate[2];
				formData.checkOutDate = yearOfCheckOutDate + '-' + monthOfCheckOutDate + '-' + dayOfCheckOutDate;
			}
			if (splitDateOfCheckOutDate[0].length == 4) {
				let yearOfCheckOutDate = splitDateOfCheckOutDate[0];
				let monthOfCheckOutDate = splitDateOfCheckOutDate[1];
				let dayOfCheckOutDate = splitDateOfCheckOutDate[2];
				formData.checkOutDate = yearOfCheckOutDate + '-' + monthOfCheckOutDate + '-' + dayOfCheckOutDate;
			}
		}
	} else {
		formData.checkOutDate = '';
	}

	this.showQuoteWindow = false;

	this.openCreateReservationPopUp(formData.shortTermRentalId, formData.checkInDate, formData.checkOutDate, formData.numAdults, formData.numChildren);

}

patchDates()
{
	if (this.form1) {
		if (this.quoteCheckInDate) {
			this.form1.patchValue({
				checkInDate: this.quoteCheckInDate
			});
			this.quoteMinCheckOutDate = this.form1.get('checkInDate').value;
		}
	}
}

	/**
	 *  Show records between availability or actual Rate from RateLos
	 */
	switchTapeChartView(event)
	{
		this.getTapeChartDetails(this.currentSearchForm, null);
	}

	/**
	 * Search Rates for given number of nights
	 * @param numNights
	 */
	onNumNightsChange(numNights)
	{
		this.currentSearchForm['searchWithLosNights'] = numNights;
		this.getTapeChartDetails(this.currentSearchForm, null);
	}

	/**
	 * Add time plus local time GMT hours as http request change time to UTC time
	 * @param datetime
	 * @returns
	 */
	addLocalTimeToDateTime(datetime) {
		return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
	}

	/**
	 * new Date('String Date') creates date with timezone offset hence this method add timezone hours
	 * @param datetime
	 * @returns
	 */
	addTimeOffsetToLocalDateTime(datetime) {
		let offsetMin = datetime.getTimezoneOffset();
		// If positive means timezone is in minus of UTC
		if (offsetMin > 0)
		{
			return new Date(datetime.getTime() + (datetime.getTimezoneOffset() * 60000));
		}
		else
		{
			return new Date(datetime.getTime() - (datetime.getTimezoneOffset() * 60000));
		}
	}
	
	openTripPlanner(): void {
	  this.tripPlannerVisible = true;
	}
}
